import React from 'react'
import classNames from 'classnames'

import { ReactComponent as PlanIcon } from '../../../assets/svg/icons/plan-icon.svg'

import '../../../assets/sass/components/plans/plan-price-card.scss'

const PlanPriceCard = ({
    plan,
    price,
    info,
    hint
}) => {
    return (
        <div className={classNames("plan-price-card", plan)}>
            <PlanIcon className="icon" />
            <h6 className="plan-name">{plan}</h6>
            <h5 className="price">${price}</h5>
            <p className="info">{info}</p>
            <span className="hint">{hint}</span>
        </div>
    )
}

export default PlanPriceCard
